import styles from './Skeleton.module.css';

export function Bone({ width = '100%', height = '1rem', radius = 6, style }) {
  return (
    <span
      className={styles.bone}
      style={{ width, height, borderRadius: radius, ...style }}
    />
  );
}

export function StatCardSkeleton() {
  return (
    <div className={styles.statCard}>
      <Bone width="55%" height="11px" />
      <Bone width="45%" height="36px" />
      <Bone width="35%" height="11px" />
    </div>
  );
}

export function SectionSkeleton({ rows = 5 }) {
  return (
    <div className={styles.section}>
      <div className={styles.sectionHeader} />
      {Array.from({ length: rows }).map((_, i) => (
        <div
          key={i}
          className={styles.row}
          style={{ width: i % 3 === 2 ? '65%' : '100%' }}
        />
      ))}
    </div>
  );
}

const BAR_HEIGHTS = ['55%', '80%', '40%', '95%', '65%', '75%', '50%'];

export function BarChartSkeleton({ height = 280 }) {
  return (
    <div className={styles.barChart} style={{ height }}>
      <div className={styles.barChartBars}>
        {BAR_HEIGHTS.map((h, i) => (
          <Bone key={i} className={styles.bar} width="100%" height={h} radius={4} />
        ))}
      </div>
      <div className={styles.barChartBaseline} />
    </div>
  );
}
